import { useApolloClient } from "@apollo/client";
import React, { useEffect } from "react";
import { GetSingleChargeDocument } from "~/charges-table/singleChargeQuery.generated";
import { ProjectCharge } from "~/gql/types";

type SingleChargeLoaderProps = {
  dependency: boolean;
  callback: (charge: ProjectCharge) => void;
  id: number;
  onError?: (error: unknown) => void;
};

export const SingleChargeLoader: React.FC<SingleChargeLoaderProps> = ({
  dependency,
  callback,
  id,
  onError,
}) => {
  const client = useApolloClient();

  useEffect(() => {
    if (!dependency) {
      return;
    }

    void (async () => {
      try {
        const result = await client.query({
          query: GetSingleChargeDocument,
          variables: { id },
        });
        const updatedCharge = result?.data?.projectCharges
          ?.single as ProjectCharge;
        callback(updatedCharge);
      } catch (error) {
        // A rejected re-read must not silently strand the caller. Callers reset
        // their trigger state in `onError` so a failed read can't poison the
        // path (e.g. leave an absorb id stuck non-null forever).
        onError?.(error);
      }
    })();
    // `id` is in the dep array so a non-null → non-null id transition can't
    // silently no-op; callers still gate on the `dependency` toggle.
  }, [dependency, id]);
  return <></>;
};
